/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import './ShareCardSummaryList.scss';

interface Props {
  items: any[];
  renderItem(item: any): any;
}

const ShareCardSummaryList = (props: Props) => {
  const { items, renderItem } = props;

  return (
    <ul className="cmp-sharecardsummarylist">
      {
        items.map((item, index) => {
          return (
            <li key={index}>
              {renderItem(item)}
            </li>
          );
        })
      }
    </ul>
  );
};

export default ShareCardSummaryList;
